import React from 'react'
import { Dropdown } from 'semantic-ui-react'
import { times, find, isNaN } from 'lodash'

const createDefaultOptions = (value, count = 10) => {
  const intValue = parseInt(value);
  return times(Math.max(count, isNaN(intValue) ? 0 : intValue), (n) => {
    return { key: n+1, text: n+1, value: n+1 };
  });
};

export default class QuantitySelector extends React.PureComponent {

  constructor(props) {
    super(props);

    this.state = {
      options: createDefaultOptions(props.quantity),
      currentValue: parseInt(props.quantity),
      prevCurrentValue: parseInt(props.quantity)
    }
  }

  static getDerivedStateFromProps(props, state) {
    const { quantity } = props;
    const { prevCurrentValue} = state;

    if(prevCurrentValue !== quantity ) {
      return {
        prevCurrentValue: quantity,
        currentValue: quantity,
        options: createDefaultOptions(quantity),
      }

    }
    return null;
  }

  handleAddition = (e, { value }) => {
    this.setState({
      options: createDefaultOptions(value)
    })
  };

  handleChange = (e, { value }) => {
    const { onChange } = this.props;

    const intValue = parseInt(value);

    const newOptions = createDefaultOptions(value);

    if(find(newOptions, {value: intValue})) {
      this.setState({ currentValue: intValue });

      if(onChange) {
        onChange(intValue);
      }
    }
  };


  render() {
    const { currentValue } = this.state
    const { disabled } = this.props;

    return (
      <Dropdown
        options={this.state.options}
        search
        selection
        allowAdditions
        value={currentValue}
        onAddItem={this.handleAddition}
        onChange={this.handleChange}
        additionLabel=''
        disabled={ disabled }
        style={{minWidth: 64}}
      />
    )
  }
}
